import { useMemo } from 'react';

const filterItems = (items, searchString, searchFields) =>
  items.filter(item =>
    searchFields.some(field =>
      item[field]
        ?.toString()
        .toLowerCase()
        .includes(searchString.toLowerCase())
    )
  );

export const useMemoizedSearchFilter = (itemsArrayToBeFiltered, searchString, searchFields) =>
  useMemo(
    () =>
      searchString === ''
        ? itemsArrayToBeFiltered
        : filterItems(itemsArrayToBeFiltered, searchString, searchFields),
    [itemsArrayToBeFiltered, searchString]
  );
